// autolayout/measure - S48.2a.
// medirBloque(texto, fontSize)
//   Heuristica simple para estimar { wMm, hMm } de un bloque de texto a
//   un fontSize dado. Retorna dimensiones en mm asumiendo:
//     - 1 char ~= fontSize * 0.55 px de ancho.
//     - line height ~= fontSize * 1.2 px.
//     - 96 dpi web -> 1 mm = 96/25.4 px ~= 3.7795 px.
//   Si el texto trae '\n', cada linea cuenta como linea separada.
//   Si pasa array, se trata como lineas precalculadas.

const PX_PER_MM = 96 / 25.4;
const CHAR_WIDTH_RATIO = 0.55;
const LINE_HEIGHT_RATIO = 1.2;

function _splitLines(texto) {
  if (Array.isArray(texto)) return texto.map((s) => String(s || ''));
  if (texto == null) return [''];
  const s = String(texto);
  if (s.indexOf('\n') === -1) return [s];
  return s.split('\n');
}

export function medirBloque(texto, fontSize) {
  const lineas = _splitLines(texto);
  const fs = Math.max(1, Number(fontSize) || 8);
  let maxLen = 0;
  for (let i = 0; i < lineas.length; i += 1) {
    const ln = lineas[i];
    if (ln.length > maxLen) maxLen = ln.length;
  }
  const wPx = maxLen * fs * CHAR_WIDTH_RATIO;
  const hPx = lineas.length * fs * LINE_HEIGHT_RATIO;
  return {
    wMm: wPx / PX_PER_MM,
    hMm: hPx / PX_PER_MM,
    lines: lineas.length,
    fontSize: fs,
  };
}
